// import { tns } from 'tiny-slider/src/tiny-slider';
import Splide from '@splidejs/splide';
import { firebase } from './firebase';

class Debouncer {
  static DefaultTimeout = 100;
  debounceTimerList = [];
  debounceFlagList = [];

  debounce(callback, timeMilliseconds = Debouncer.DefaultTimeout) {
    let index = this.debounceTimerList.length;
    return (event) => {
      clearTimeout(this.debounceTimerList[index]);
      this.debounceTimerList[index] = setTimeout(() => callback(event), timeMilliseconds);
    }
  }
  debounceFlag(callback, timeMilliseconds = Debouncer.DefaultTimeout) {
    let index = this.debounceFlagList.length;
    return (event) => {
      if (this.debounceFlagList[index]) {
        return ;
      }
      this.debounceFlagList[index] = true;

      setTimeout(() => {
        callback(event);
        this.debounceFlagList[index] = false;
      }, timeMilliseconds);
    }
  }
  clear() {
    if (this.debounceTimerList.length) {
      this.debounceTimerList.forEach((intervalId) => clearInterval(intervalId));
    }
  }
}

class EventHandler {
  eventStore = new Map();

  on(element, type, listener, params) {
    if (type === 'mediaQuery') {
      element.addListener(listener, params);
    }
    else {
      element.addEventListener(type, listener, params);
    }

    let eventList = this.eventStore.get(element) || [];
    eventList.push({type, listener});
    this.eventStore.set(element, eventList);
  }
  off(element) {
    if (!this.eventStore.has(element)) {
      return ;
    }

    this.eventStore.get(element).forEach(({type, listener}) => {
      if (type === 'mediaQuery') {
        element.removeListener(listener);
      }
      else {
        element.removeEventListener(type, listener);
      }
    });
  }
  offAll() {
    this.eventStore.forEach((eventInfo, element) => this.off(element));
  }
}

class Application extends EventHandler {
  debouncer = new Debouncer();

  constructor() {
    super();

    // seal 'this' reference to current instance
    // Object.getOwnPropertyNames(Object.getPrototypeOf(this))
    //  .filter((method) => method !== 'constructor' && typeof method === 'function')
    //  .forEach((method) => this[method].bind(this))
    // ;

    if (this.isPrivacyPolicyPage) {
      return ;
    }
    setInterval(() => {
      var i = 1; document.querySelectorAll('.splide__pagination__page').forEach((el) => {
          el.innerText = i++;
      });
    }, 1000);
    setInterval(() => {
      this.smallMenuInnerScroll();
    }, 500);
  }
  get isPrivacyPolicyPage() {
    return window.location.pathname.includes('privacy-policy') || window.location.pathname.includes('policy');
  }

  onBeforePageReady() {
    this.handleFirebaseLogic();
  }

  async onContentLoaded() {
    // Let's not create reference for HtmlElements as class properties for better memory control

    if (this.isPrivacyPolicyPage) {
      this.handleLangSelect();
      this.handleAnalyticEvents();
      return ;
    }

    this.handleInvite();
    this.handleLangSelect();
    this.handleFaq();
    this.handleAnalyticEvents();

    let menuElement = document.querySelector('header .main-menu');
    let progressElement = menuElement.querySelector('.menu-bar-progress');
    let activeElementRef = {
      ref: null
    };
    let menuOptionContainer = menuElement.querySelector('nav');
    let menuOptionList = Array.from(menuOptionContainer.querySelectorAll('a'));

    this.handleMenuSelection({menuElement, progressElement, activeElementRef, menuOptionContainer, menuOptionList});
    this.handleMenuPosition({menuElement, progressElement, activeElementRef, menuOptionList});

    let customerBlockContainer = document.querySelector('.block-customers');
    let customerSliderContainer = customerBlockContainer.querySelector('.block-customers .customer-slider');
    let reviewContainer = customerSliderContainer.querySelector('.customer-list');
    await this.handleReviews(customerBlockContainer, reviewContainer);
    this.handleSliderMedia(customerSliderContainer, reviewContainer);
  }

  urlParamMap = null;
  firebase = null;
  firebaseReadyLock = null;
  inviteParams = ['referralId', 'referralUUid', 'basketId', 'storageId', 'basketName', 'storageName'];

  get isInviteAvailable() {
    return Boolean(this.urlParamMap);
  }
  async handleFirebaseLogic() {
    let urlParamMap = new Map(new URLSearchParams(window.location.search));
    this.firebaseReadyLock = this.createPromiseLock();
    if (urlParamMap.size) {
      this.urlParamMap = urlParamMap;
    }

    this.firebase = firebase;
    // this.firebase = (await import('./firebase')).firebase;
    this.firebaseReadyLock.resolve();
  }
  async handleInvite() {
    let inviteContainer = document.querySelector('header .header-phone');
    if (!this.isInviteAvailable) {
      inviteContainer.classList.remove('is-loading');
      inviteContainer.classList.add('is-auth-now');
      return ;
    }

    let profileImgElement = inviteContainer.querySelector('.phone-screen-profile img');
    let profileNameElement = inviteContainer.querySelector('.phone-message strong');
    let acceptLinkElement = inviteContainer.querySelector('.phone-btn-accept');

    let inviteRedirectParamString = '';
    this.inviteParams.forEach((key) => {
      if (this.urlParamMap.has(key)) {
        inviteRedirectParamString += `&${key}=${this.urlParamMap.get(key)}`;
      }
    });
    if (inviteRedirectParamString) {
      acceptLinkElement.setAttribute('href', acceptLinkElement.href + inviteRedirectParamString);
    }

    await this.firebaseReadyLock;
    let inviteResponse = {data: {}};
    try {
      inviteResponse = await this.firebase.functions().httpsCallable('getInvitedGuestProfile')({
        referralId: this.urlParamMap.get('referralUUid'),
      });
    } catch (error) {
      console.error(error, inviteResponse);
      inviteResponse = {data: {}};
    }

    if (inviteResponse.data.photoUrl) {
      profileImgElement.setAttribute('src', inviteResponse.data.photoUrl);
    }
    if (inviteResponse.data.name) {
      profileNameElement.textContent = inviteResponse.data.name;
    }

    inviteContainer.classList.remove('is-loading');
    if (!inviteResponse.data.photoUrl && !inviteResponse.data.name) {
      inviteContainer.classList.add('is-auth-now');
    }
  }

  createPromiseLock() {
    let resolveLink = null;
    let rejectLink = null;
    let promise = new Promise(((resolve, reject) => {
      resolveLink = resolve;
      rejectLink = reject;
    }));

    promise.resolve = resolveLink;
    promise.reject = rejectLink;

    return promise;
  }

  handleLangSelect() {
    let translateConfig = nodeApp.translationConfig;
    let langSelectElement = document.querySelector('.lang .lang-select select');

    this.on(langSelectElement, 'change', this.onLangChange.bind(this, translateConfig, langSelectElement));
  }
  onLangChange(translateConfig, langSelectElement) {
    document.cookie = `firebase-language-override=${langSelectElement.value}`;
    window.location.reload()
  }

  async handleAnalyticEvents() {
    await this.firebaseReadyLock;

    document.querySelectorAll('a').forEach((linkElement) => {
      if (linkElement.href.includes('id=com.vptitsyn.buysmthlite')) {
        this.on(linkElement, 'click', () => {
          this.firebase.analytics().logEvent('web_got_on_google_play_lite');
        }, true);
      } else if (linkElement.href.includes('id=com.vptitsyn.buysmth')) {
        this.on(linkElement, 'click', () => {
          this.firebase.analytics().logEvent('web_got_on_google_play');
        }, true);
      } else if (linkElement.href.includes('id=Vitaliy+Ptitsyn')) {
        this.on(linkElement, 'click', () => {
          this.firebase.analytics().logEvent('web_see_dev_acount');
        }, true);
      }
    });
  }

  prevProgressPositionClass = '';
  sectionIdList = [];

  handleMenuSelection(params) {
    let {
      menuElement,
      progressElement,
      activeElementRef,
      menuOptionContainer,
      menuOptionList} = params;
    let optionMap = new Map(
      menuOptionList.map((linkElement) => [linkElement.getAttribute('href'), linkElement])
    );
    optionMap.forEach((menuElement, menuId) => {
      this.sectionIdList.push(menuId);
    });

    // menu initialization
    let hash = window.location.hash || '#';
    let activeLinkElement = optionMap.get(hash) || menuOptionList[0];
    activeElementRef.ref = activeLinkElement;
    activeLinkElement.classList.add('is-active');

    //force scroll to hash position
    if (activeElementRef.ref !== menuOptionList[0]) {
      window.location.assign(window.location.hash);
    }

    // progress bar initialization
    this.showProgress(progressElement, menuOptionList, activeElementRef);

    this.on(menuOptionContainer, 'click', this.onMenuSelect.bind(this, {
      activeElementRef,
      menuOptionList,
      progressElement
    }));
    this.onMenuHover(menuElement);
  }

  isMenuFocused = false;
  //hover mode with mobile support
  onMenuHover(menuElement) {
    this.on(menuElement, 'click', () => {
      this.focusMenu(menuElement);
    });
    this.on(menuElement, 'focus', () => {
      this.focusMenu(menuElement);
    });
    this.on(menuElement, 'mouseenter', () => {
      this.focusMenu(menuElement);
    });
    this.on(menuElement, 'mouseleave', () => {
      this.unFocusMenu(menuElement);
    });
    this.on(document.querySelector('main'), 'touchstart', () => {
      this.unFocusMenu(menuElement);
    }, true);
  }
  focusMenu(menuElement) {
    if (!menuElement.classList.contains('is-focused')) {
      menuElement.classList.add('is-focused');
    }
  }
  unFocusMenu(menuElement) {
    if (menuElement.classList.contains('is-focused')) {
      menuElement.classList.remove('is-focused');
    }
  }

  isMenuTransition = false;

  onMenuSelect(params, event) {
    let {
      activeElementRef,
      menuOptionList,
      progressElement
    } = params;
    if (event.target.nodeName.toLowerCase() !== 'a') {
      return ;
    }

    this.isMenuTransition = true;
    this.changeActiveMenuOption(activeElementRef, event.target);
    this.showProgress(progressElement, menuOptionList, activeElementRef);
  }
  changeActiveMenuOption(activeElementRef, nextElement) {
    activeElementRef.ref.classList.remove('is-active');
    nextElement.classList.add('is-active');
    activeElementRef.ref = nextElement;
  }
  showProgress(progressElement, menuOptionList, activeElementRef) {
    let optionIndex = menuOptionList.indexOf(activeElementRef.ref);
    this.showProgressByIndex(progressElement, optionIndex);
  }
  showProgressByIndex(progressElement, optionIndex) {
    if (this.prevProgressPositionClass) {
      progressElement.classList.remove(this.prevProgressPositionClass);
    }
    this.prevProgressPositionClass = `progress-state-${optionIndex}`;
    progressElement.classList.add(this.prevProgressPositionClass);
  }

  menuOffsetMap = {
    stickyTopOffset: 50,
    containerTop: 40,
    containerPadding: 50,
  };
  scrollArray = [];

  handleMenuPosition(params) {
    let {
      menuElement,
      progressElement,
      activeElementRef,
      menuOptionList
    } = params;
    let menuContainer = menuElement.parentNode;


    let menuStyleMap = window.getComputedStyle(menuElement);
    if (menuStyleMap.getPropertyValue) {
      this.menuOffsetMap.containerTop = parseInt(menuStyleMap.getPropertyValue('--menu-top-offset'),10)
        || this.menuOffsetMap.containerTop;
      this.menuOffsetMap.containerPadding = parseInt(menuStyleMap.getPropertyValue('--menu-container-padding'),10)
        || this.menuOffsetMap.containerPadding;
    } else {
      console.warn('getPropertyValue for css var is not supported. ' +
        'Can not sync offset with js, fallback defaults will be used instead');
    }
    this.menuOffsetMap.threshold = menuContainer.offsetTop - this.menuOffsetMap.containerTop - this.menuOffsetMap.stickyTopOffset;

    // create, assign and execute (initialization) listener
    let scrollListener = this.debouncer.debounceFlag(this.onScroll.bind(this, {
      menuElement,
      menuContainer,
      progressElement,
      activeElementRef,
      menuOptionList,
    }));
    this.on(window, 'scroll', scrollListener);
    scrollListener();

    let largeScreenMedia = window.matchMedia('(min-width: 1440px)');
    this.on(largeScreenMedia, 'mediaQuery', this.debouncer.debounceFlag(this.onMediaLargeScreen.bind(this, {
      menuContainer,
      menuElement,
    })));
  }
  getSectionViewOffset(id) {
    if (id === this.sectionIdList[0]) {
      return 0;
    }

    let viewerOffset = 300;
    let viewerOffsetLong = 800;

    let offset = window[id] && window[id].offsetTop || document.querySelector('section' + id).offsetTop;
    let isLastSection = id === this.sectionIdList[this.sectionIdList.length - 1];

    offset -= isLastSection ? viewerOffsetLong : viewerOffset;
    return offset;
  }
  onScroll(paramList, event) {
    paramList.scrollTop = document.documentElement.scrollTop;
    this.menuStickToggle(paramList);
    this.animateMenuFromScroll(paramList);
  }
  onMediaLargeScreen(params, event) {
    let {menuContainer, menuElement} = params;
    let isSticky = this.isThresholdPassed(document.documentElement.scrollTop) && menuElement.classList.contains('is-sticky');
    if (!isSticky) {
      return;
    }

    if (event.target.matches) {
      menuElement.removeAttribute('style');
      return;
    }

    menuElement.removeAttribute('style');
    this.setMenuSideOffset(menuElement, menuContainer);
  }
  isThresholdPassed(scrollTop) {
    return scrollTop > this.menuOffsetMap.threshold;
  }

  menuStickToggle(paramList) {
    let {
      scrollTop,
      menuElement,
      menuContainer,
    } = paramList;

    // console.log(scrollTop, menuOffsetMap);

    if (this.isThresholdPassed(scrollTop) && !menuElement.classList.contains('is-sticky')) {
      this.setMenuSideOffset(menuElement, menuContainer);
      menuElement.classList.add('is-sticky');
    }
    else if (scrollTop <= this.menuOffsetMap.threshold && menuElement.classList.contains('is-sticky')) {
      menuElement.classList.remove('is-sticky');
      menuElement.removeAttribute('style');
    }
  }
  setMenuSideOffset(menuElement, menuContainer) {
    let menuContainerRect = menuContainer.getBoundingClientRect();
    let isOffsetUnSet = !menuElement.hasAttribute('style') || !menuElement.getAttribute('style');

    if (menuContainerRect.left - this.menuOffsetMap.containerPadding > 0 && isOffsetUnSet) {
      let offsetRight = parseInt(window.getComputedStyle(menuElement).right, 10);
      menuElement.style.right = (offsetRight + menuContainerRect.left) + 'px';
    }
  }

  animateMenuFromScroll(paramList) {
    // Generate top scroll levels map of sections:
    this.scrollArray = this.sectionIdList.map((id) => {
      return this.getSectionViewOffset(id);
    });
    // console.log(this.scrollArray);

    let optionIndex = 0;
    for (; optionIndex < this.scrollArray.length; ++optionIndex) {
      if (this.scrollArray[optionIndex] > paramList.scrollTop) {
        break;
      }
    }

    paramList.visibleSectionIndex = Math.max(optionIndex - 1, 0);
    // console.log({ visibleSectionIndex });

    this.debouncer.debounce(this.onAnimateMenuScrollFinish.bind(this, paramList))();
  }
  onAnimateMenuScrollFinish(paramList) {
    if (this.isMenuTransition) {
      this.isMenuTransition = false;
      return ;
    }

    let {
      menuElement,
      progressElement,
      activeElementRef,
      menuOptionList,
      visibleSectionIndex
    } = paramList;
    this.showProgressByIndex(progressElement, visibleSectionIndex);

    const isActiveClass = 'is-active';
    if (!activeElementRef.ref) {
      return ;
    }

    menuElement.querySelectorAll('a.' + isActiveClass).forEach((element) => {
      if (menuOptionList[visibleSectionIndex].classList !== element.classList) {
        element.classList.remove(isActiveClass);
      }
    });
    menuOptionList[visibleSectionIndex].classList.add(isActiveClass);
    activeElementRef.ref = menuOptionList[visibleSectionIndex];

    this.smallMenuInnerScroll();
  }

  smallMenuInnerScroll() {
    // If menu is in small and transparent mode and not .is-focused then we scroll it so current selected menu item is always in center, else this tranformation should be cleared.
    // Check if menu is in small and transparent mode and not .is-focused.
    const menu = document.querySelector('.main-menu');
    const isMenuSmallAndTransparent = menu.offsetHeight < 200 && menu.classList.contains('is-sticky') && !menu.classList.contains('is-focused');
    const DEFAULT_SCROLL = 0;
    const scrollMenu = (menuNode, howMuch) => {
      menuNode.childNodes.forEach(node => {
        if (node.style) {
          node.style.transform = `translateY(-${howMuch}px)`;
        }
      });
    };
    const howMuchToScrollBasedOnSelectedMenuItem = () => {
      let menuItemHeightSum = 0;
      Array.prototype.slice.call(menu.querySelectorAll('nav > *')).some(menuItem => {
        menuItemHeightSum += menuItem.offsetHeight;
        return menuItem.querySelector('.is-active');
      });
      return menuItemHeightSum - menu.querySelectorAll('nav > *')[0].offsetHeight;
    };
    const howMuchToScroll = isMenuSmallAndTransparent ? howMuchToScrollBasedOnSelectedMenuItem() : DEFAULT_SCROLL;
    // console.log({howMuchToScroll});
    scrollMenu(menu, howMuchToScroll);
  }

  handleFaq() {
    let faqList = document.querySelector('.block-faq .question-list');
    this.on(faqList, 'click', this.onQuestionToggle);
  }
  onQuestionToggle(event) {
    if (event.target.nodeName.toLocaleLowerCase() !== 'h4') {
      return ;
    }

    let faqElement = event.target.parentNode;
    if (faqElement.classList.contains('is-active')) {
      faqElement.classList.remove('is-active');
    }
    else {
      let questionElementList = Array.from(document.querySelectorAll('.card.card-question'));
      questionElementList.forEach((el) => {
        el.classList.remove('is-active');
      });
      faqElement.classList.add('is-active');
      if (this.firebase && this.firebase.analytics) {
        this.firebase.analytics().logEvent('web_faq', {value: questionElementList.indexOf(faqElement)});
      }
    }
  }

  reviewList = []

  async getReviews() {
    let reviewResponse;
    try {
      reviewResponse = await this.firebase.functions().httpsCallable('getReviews')({
        lang: document.documentElement.lang,
      });
    } catch (error) {
      console.error(error, reviewResponse);
      reviewResponse = {data: []};
    }

    return reviewResponse.data;
  }
  async handleReviews(customerBlockContainer, reviewContainer) {
    this.reviewList = await this.getReviews();

    let templateReviewList = '';
    for (let index = 0; index < this.reviewList.length; ++index) {
      templateReviewList += this.createReviewTemplate(this.reviewList[index]);
    }

    if (customerBlockContainer.classList.contains('customer-list-loading')) {
      customerBlockContainer.classList.remove('customer-list-loading');
    }
    reviewContainer.insertAdjacentHTML('beforeend', templateReviewList);

    this.on(reviewContainer, 'click', this.onReviewClick);
  }
  onReviewClick(event) {
    let element = event.target;
    while (element !== event.currentTarget && !element.classList.contains('card-customer')) {
      element = element.parentNode;
    }
    if (element === event.currentTarget) {
      return ;
    }

    // if (this.firebase && this.firebase.analytics) {
    //   this.firebase.analytics().logEvent('web_got_on_google_play');
    // }
    let id = element.dataset.id || '';
    window.location.assign(`https://play.google.com/store/apps/details?id=com.vptitsyn.buysmth&install_referrer=landing&reviewId=${encodeURIComponent(id)}`);
    // window.open(`https://play.google.com/store/apps/details?id=com.vptitsyn.buysmth&install_referrer=landing&reviewId=${encodeURIComponent(id)}`, '_blank');
  }
  createReviewTemplate(review) {
    let ratingString = '';
    for (let rateIndex = 0; rateIndex < review.score; rateIndex+= 1) {
      ratingString += '<span class="card-customer-star"></span>';
    }

    let date = (new Date(review.date)).toLocaleString('default', { month: 'long', year: 'numeric', day: 'numeric' });

    return (
`  <div class="card card-customer" data-id="${review.id}">
    <p><strong>${review.userName}</strong></p>
    <p>
      <span class="card-customer-rating">
        ${ratingString}
      </span>
      <span class="card-customer-date">${date}</span>
    </p>
    <div class="card-customer-thumb-wrap">
      <span class="card-customer-thumb-up"></span><br/><span class="card-customer-thumb-count">${review.thumbsUp}</span>
    </div>
    <div class="card-customer-img">
      <img src="${review.userImage}" alt="" />
    </div>
    <p class="card-customer-text">${review.text}</p>
  </div>`);
  }
  handleSliderMedia(customerSliderContainer, reviewContainer) {
    let reviewElementList = reviewContainer.querySelectorAll('.card-customer');

    let phoneMedia = window.matchMedia('(max-width: 699px)');
    let tabletMedia = window.matchMedia('(min-width: 700px) and (max-width: 1023px)');
    let screenMedia = window.matchMedia('(min-width: 1024px)');
    phoneMedia.itemPerCol = 1;
    tabletMedia.itemPerCol = 4;
    screenMedia.itemPerCol = 6;

    let mediaList = [phoneMedia, tabletMedia, screenMedia];
    mediaList.forEach((mediaItem) => {
      this.on(mediaItem, 'mediaQuery', this.onSliderMedia.bind(this, {
        reviewContainer,
        reviewElementList,
        itemPerCol: mediaItem.itemPerCol
      }));
    });

    let media = mediaList.find((media) => media.matches);
    this.onSliderMedia({reviewContainer, reviewElementList, itemPerCol: media.itemPerCol}, {target: {matches: true}});
  }

  sliderOptions = {
    type: 'fade',
    // easing: 'ease',
    // classes: {
    //   prev  : 'btn-slide customer-btn-left',
    //   next  : 'btn-slide customer-btn-right',
    // },
  }
  onSliderMedia(params, event) {
    if (!event.target.matches) {
      return ;
    }

    let {itemPerCol, reviewContainer, reviewElementList} = params;
    while(reviewContainer.firstChild) {
      reviewContainer.removeChild(reviewContainer.lastChild);
    }

    let index = 0;
    let reviewColTpl = null;
    while (index < reviewElementList.length) {
      reviewColTpl = document.createElement('div');
      reviewColTpl.setAttribute('class', `splide__slide customer-col customer-col-${index}`);
      for (let indexCol = 0; indexCol < itemPerCol; ++indexCol) {
        if (index >= reviewElementList.length) {
          break;
        }

        reviewColTpl.appendChild(reviewElementList[index]);
        index += 1;
      }
      reviewContainer.appendChild(reviewColTpl);
    }

    if (Boolean(this.slider)) {
      this.slider = this.slider.refresh();
      this.slider.go(0);
    }
    else {
      this.slider = new Splide( '.block-customers .splide',  this.sliderOptions).mount();
    }
  }

  clear() {
    if (this.eventStore) {
      this.offAll();
      this.eventStore.clear();
    }
    if (this.slider) {
      this.slider.destroy();
    }
    this.debouncer.clear();
  }
}


let app = new Application();
app.onBeforePageReady();
document.addEventListener('DOMContentLoaded', () => app.onContentLoaded());
// not clear for android cache on page change
// window.addEventListener('beforeunload', () => app.clear());